import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { SharedDsnModule } from "@app/shared/modules/shared-dsn.module";
import { SharedMaterialModule } from "@app/shared/modules/shared-material.module";
import { VisualizationEntity } from "@arch/domain/entity";

@Component({
    selector: "app-interactions-dialog",
    imports: [SharedMaterialModule, SharedDsnModule],
    templateUrl: "./interactions-dialog.component.html",
    styleUrl: "./interactions-dialog.component.scss"
})
export class InteractionsDialogComponent implements OnInit {
    constructor(
        public dialogRef: MatDialogRef<InteractionsDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: InputInteractionsDialogType
    ) {}

    ngOnInit(): void {}
}

type InputInteractionsDialogType = {
    visualization: VisualizationEntity;
};
